import {
  getStorage,
  ref,
  uploadString,
} from "firebase/storage";

const storage = getStorage();

export async function createFolder(folderPath) {
  // Define the path for the hidden file within the new directory
  const ghostFilePath = `${folderPath}/.ghostfile`;
  const ghostFileRef = ref(storage, ghostFilePath);

  // Upload an empty string to create the reference
  await uploadString(ghostFileRef, "");
  console.log(`Folder '${folderPath}' created successfully with a ghost file.`);
}
